<span
  [class.sort-by-selected]="isSelected$ | async"
  [class.sort-by-asc]="isAscending$ | async"
  [class.sort-by-desc]="isDescending$ | async"
  (click)="onClick()"
>
  <ng-content></ng-content>
</span>
